const styles = (theme) => ({
  // Título "Informações do Host"
  title: {
    fontWeight: 700,
    px: 1,
    color: theme.palette.text.primary,
    fontSize: "0.95rem",
    letterSpacing: "0.01em",
  },

  // Cada seção de informação
  infoSection: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "flex-start",
  },

  // Valor de campo simples (texto)
  infoValue: {
    fontWeight: 500,
    //wordBreak: "break-all",
    color: theme.palette.text.secondary,
    mt: -0.25,
  },

  // Container de chips
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.4,
  },

  // Chip de grupo
  chipGroup: {
    fontWeight: 500,
    fontSize: "0.72rem",
    color: theme.palette.white.main,
  },

  // Chip de etiqueta/tag
  chipTag: {
    fontWeight: 500,
    fontSize: "0.72rem",
    color: theme.palette.white.main,
  },

  // Chip de macro (outlined)
  chipMacro: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
    fontFamily: "monospace",
    fontSize: "0.68rem",
  },

  // Header da seção
  headerContainer: {
    display: "flex",
    alignItems: "center",
    gap: 0.4,
  },

  // Ícone do header
  headerIcon: {
    color: theme.palette.primary.main,
    display: "flex",
    mt: -0.4,
  },

  // Label do header
  headerLabel: {
    fontWeight: 700,
    textTransform: "uppercase",
  },

  // Box de carregamento
  loadingBox: {
    display: "flex",
    gap: 0.8,
    flexWrap: "wrap",
  },

  // Texto quando não há itens
  emptyText: {
    color: theme.palette.text.disabled,
    mt: -0.2,
  },

  // Container principal do HostInfo
  paper: {
    display: "flex",
    width: "100%",
    gap: 1,
    p: 1,
    flexDirection: "column",
    borderRadius: 4,
  },

  // Linha divisória
  divider: {
    mx: "-8px",
    borderColor: theme.palette.divider,
  },

  boxMacro: {
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    alignItems: "center",
  },

  cardHostInfo: {
    display: "flex",
    width: "100%",
    height: "100%",
    bgcolor: theme.palette.background.wallpaper,
    borderRadius: 4,
    p: 2,
  },
});

export default styles;
